// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from 'react';
import './ImageSquare.scss';
import { fetchImageThumbnailUrl } from '../../shared_components/utils/ImgUtils';
import { AlertTriangle } from 'lucide-react';

export default function ImageSquare({
  storage,
  imageStoragePath,
  setGreyedOut = false,
  icons = [],
  hasImageQualityIssues = false,
  size = 100,
  imageUrl,
  containerClassName,
  imageClassName,
  topRightIcon,
  topRightIconClassName,
}) {
  const [imageUrlAuth, setImageUrlAuth] = React.useState(imageUrl || '');
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    if (!imageStoragePath) return;
    if (imageStoragePath.startsWith('data:image')) {
      // This means it is not actually an URL but the image data itself
      setImageUrlAuth(imageStoragePath);
    } else {
      fetchImageThumbnailUrl(storage, imageStoragePath).then((url) => {
        setImageUrlAuth(url);
      });
    }
  }, [imageStoragePath]);

  return (
    <div className={`image_square image_square--size-${size} ${containerClassName}`}>
      {topRightIcon && <div className={`image_square--top-right-icon ${topRightIconClassName}`}>{topRightIcon}</div>}
      {imageUrlAuth && (
        <img
          alt='bale image'
          className={`image_square--img ${setGreyedOut && 'greyed-out'} ${hasImageQualityIssues ? 'has-image-issues' : ''} ${imageClassName}`}
          src={imageUrlAuth}
          onLoad={() => setIsLoaded(true)}
          style={{ display: isLoaded ? 'block' : 'none' }}
        />
      )}
      {icons && (
        <div className='image_square--icons-container'>
          {icons.map((icon, index) => {
            return <img key={index} className='image_square--icon' src={icon} />;
          })}
        </div>
      )}
      {hasImageQualityIssues && (
        <div className='image_square--image-quality-warning'>
          <AlertTriangle size={16} />
        </div>
      )}
    </div>
  );
}
